export function openEditModal(
    modalType,
    editSiteSetup,
    setModalState,
    showCenterOfGreens,
    showTeeMarkers,
    showPointsOfInterest,
    setOpenModel,
    setOpenAreaWindow,
    setEditModel,
) {
    if (editSiteSetup.get() && modalType !== undefined) {
      setModalState(modalType);
      if (
        showCenterOfGreens.get() ||
        showTeeMarkers.get() ||
        showPointsOfInterest.get()
      ) {
        setOpenModel(false);
        setOpenAreaWindow(false);
        setEditModel(true);
      }
    }
  }